import { apiClient } from '@/config/api';
import { DeviceType, HydraCollection } from '@/types';

export const deviceTypeService = {
  // Get all device types
  async getDeviceTypes(): Promise<DeviceType[]> {
    const response = await apiClient.get<HydraCollection<DeviceType>>('/device_types', {
      params: {
        'groups[]': ['deviceType:read'],
      },
    });

    const data = response.data;
    const deviceTypes = data['hydra:member'] || data['member'] || [];
    return deviceTypes;
  },
};
